export const CATEGORIES_REQUEST = 'CATEGORIES_REQUEST';
export const CATEGORIES_REQUEST_SUCCESS = 'CATEGORIES_REQUEST_SUCCESS';
export const CATEGORIES_REQUEST_FAILED = 'CATEGORIES_REQUEST_FAILED';
export const CATEGORIES_ADD_ROUTES = 'CATEGORIES_ADD_ROUTES';
